/**
 * List of countries that need extra fields in Transfer Method Dropin-ui
 * [PAY-1215](https://vestiairecollective.atlassian.net/browse/PAY-1215)
 */

export const needExtraFieldCountries = [
  'RU', // Russia
  'CN', // China
  'JP', // Japan
  'BD', // Bangladesh
  'IL', // Israel
  'AR', // Argentina
  'CO', // Colombia
  'MY', // Malaysia
  'PK', // Pakistan
  'BR', // Brazil
  'PE', // Peru
  'AM', // Armenia
  'KZ', // Kazakhstan
  'KR', // South Korea
  'TR', // Turkey
  'TW' // Taiwan
];

/**
 * List ofcountries that requires a state field for HW
 * [PAY-1297](https://vestiairecollective.atlassian.net/browse/PAY-1297)
 */
export const stateFieldRequiredCountries = [
  'AU', // Australia
  'BR', // Brazil
  'CA', // Canada
  'IT', // Italy
  'MX', // Mexico
  'US', // United States
  'VE' // Venezuela
];
